
import './styles.css';

//////////// REACT /////////////
import React from "react";

//////////// COMPONENT /////////////
import { Modal, Button, InputGroup, FormControl, FormSelect } from 'react-bootstrap';

export function App(props) {
  // console.log(props);
  const [show, setShow] = React.useState(false);

  const [dataObject, setDataObject] = React.useState(props.data);

  const reload = () => {
    props.reload(dataObject);
    setShow(false);
  };

  const handleClose = () => { setShow(false) };
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        {props.titleButton}
      </Button>

      <Modal show={show} onHide={handleClose} style={{ zIndex: 1050 }}>
        <Modal.Header closeButton>
          <Modal.Title>{props.titleButton} sequence</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            props.form.map((form, index) => {
              return (
                <InputGroup key={index} className="custom-style-InputGroup">

                  <InputGroup.Text id="inputGroup-sizing-default" className='InputGroupTitle'>{form.displayName}</InputGroup.Text>
                  <FormControl
                    aria-label="Default"
                    aria-describedby="inputGroup-sizing-default"
                    style={{ boxShadow: "none" }}
                    type='number'
                    defaultValue={dataObject[form.attName]}
                    onChange={(event) => {

                      let dataChange = {...dataObject};
                      dataChange[form.attName] = parseFloat(event.target.value);
                      setDataObject(dataChange);

                    }}
                  />
                </InputGroup>
              );
            })
          }
        </Modal.Body>
        <Modal.Footer>
          <div style={{ flexGrow: 1 }}></div>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={reload}>SAVE</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default App;